module.exports = __webpack_public_path__ + "img/certificate-3.3edf5eff.jpg";